import { createGetAllAPI, createGetAPI, createPostAPI } from '@cuemath/rest-api';
import { stringify } from 'query-string';
import { BASE_URL } from 'constants/api';

const PREP_TASKS_URL = `${BASE_URL}/students/eval-prep-tasks`;
const PREP_COMPLIANCE_URL = `${BASE_URL}/students/eval-prep-compliance`;
const PARENT_FEEDBACK_URL = `${BASE_URL}/students/eval-parent-feedback`;

const { useGetAll: useGetAllEvalPrepTasks } = createGetAllAPI({
  getURL: query => `${PREP_TASKS_URL}/?${stringify(query || {})}`,
});

const { useGet: useGetEvalPrepTask } = createGetAPI({
  getURL: intelEnrollmentId => `${PREP_TASKS_URL}/${intelEnrollmentId}/`,
});

const { useGetAll: useGetAllEvalPrepCompliance } = createGetAllAPI({
  getURL: query => `${PREP_COMPLIANCE_URL}/?${stringify(query || {})}`,
});

const { useGetAll: useGetAllEvalParentFeedback } = createGetAllAPI({
  getURL: query => `${PARENT_FEEDBACK_URL}/?${stringify(query || {})}`,
});

const { usePost: usePostEvalComplianceReverse } = createPostAPI({
  getURL: (_, violationId) => `${PREP_COMPLIANCE_URL}/${violationId}/reverse/`,
});

export {
  useGetAllEvalPrepTasks,
  useGetEvalPrepTask,
  useGetAllEvalPrepCompliance,
  usePostEvalComplianceReverse,
  useGetAllEvalParentFeedback,
};
